
import React from 'react';
import { EnvelopeIcon, CurrencyDollarIcon, UserCircleIcon, IdentificationIcon, DevicePhoneMobileIcon } from '../../Icons';

export const ClientFormStep: React.FC<any> = ({ formData, onFormChange, errors }) => {
  const idTypes = ['Cédula de ciudadanía', 'Pasaporte', 'Cédula de extranjería'];
  const countryCodes = [{ v: '+57', l: '🇨🇴 +57' }, { v: '+1', l: '🇺🇸 +1' }, { v: '+34', l: '🇪🇸 +34' }];

  const handleIncomeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const val = e.target.value.replace(/[^0-9]/g, '');
    onFormChange({ target: { name: 'ingresos_cliente', value: val } });
  };

  const formattedIncome = formData.ingresos_cliente ? new Intl.NumberFormat('es-CO').format(parseInt(formData.ingresos_cliente)) : '';

  const inputClass = "w-full pl-11 pr-4 py-3 border-2 border-gray-100 rounded-2xl focus:ring-2 focus:ring-sky-200 focus:border-sky-500 outline-none transition-all text-sm font-bold text-gray-800 shadow-sm";
  const labelStyle = "text-[10px] font-black text-gray-400 uppercase tracking-widest mb-2 block ml-1";

  return (
    <div className="p-8 space-y-8 animate-fade-in-down">
       <div className="space-y-1">
          <h3 className="text-xl font-black text-gray-800 uppercase tracking-tight">Datos del Cliente Referido</h3>
          <p className="text-xs text-gray-500">Completa la información de tu cliente para que un Aliado pueda contactarlo.</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-6">
        <div className="md:col-span-2">
          <label className={labelStyle}>Nombre completo del cliente*</label>
          <div className="relative">
              <UserCircleIcon className="absolute left-4 top-1/2 -translate-y-1/2 text-pink-600 w-5 h-5" />
              <input type="text" name="nombre_cliente" value={formData.nombre_cliente} onChange={onFormChange} placeholder="Nombre y Apellidos del Cliente" className={inputClass} />
          </div>
        </div>

        <div>
          <label className={labelStyle}>Tipo de documento*</label>
          <select name="tipo_documento_cliente" value={formData.tipo_documento_cliente} onChange={onFormChange} className="w-full border-2 border-gray-100 rounded-2xl py-3 px-4 text-sm font-bold text-gray-800 focus:ring-2 focus:ring-sky-200 focus:border-sky-500 outline-none">
            {idTypes.map(t => <option key={t} value={t}>{t}</option>)}
          </select>
        </div>

        <div>
          <label className={labelStyle}>Número de identificación*</label>
          <div className="relative">
              <IdentificationIcon className="absolute left-4 top-1/2 -translate-y-1/2 text-pink-600 w-5 h-5" />
              <input type="text" name="numero_documento_cliente" value={formData.numero_documento_cliente} onChange={onFormChange} placeholder="Número de Documento" className={inputClass} />
          </div>
        </div>

        <div>
          <label className={labelStyle}>Celular*</label>
          <div className="flex gap-2">
            <select value={formData.countryCode_cliente} onChange={(e) => onFormChange({ target: { name: 'countryCode_cliente', value: e.target.value } })} className="w-24 border-2 border-gray-100 rounded-2xl bg-gray-50 text-xs font-black uppercase px-2">
              {countryCodes.map(c => <option key={c.v} value={c.v}>{c.l}</option>)}
            </select>
            <div className="relative flex-grow">
                <DevicePhoneMobileIcon className="absolute left-4 top-1/2 -translate-y-1/2 text-pink-600 w-5 h-5" />
                <input type="tel" name="telefono_cliente" value={formData.telefono_cliente} onChange={onFormChange} placeholder="300 000 0000" className={inputClass} />
            </div>
          </div>
        </div>

        <div>
          <label className={labelStyle}>Correo electrónico*</label>
          <div className="relative">
            <EnvelopeIcon className="absolute left-4 top-1/2 -translate-y-1/2 text-pink-600 w-5 h-5" />
            <input type="email" name="email_cliente" value={formData.email_cliente} onChange={onFormChange} placeholder="correo@cliente.com" className={inputClass} />
          </div>
        </div>

        <div className="md:col-span-2">
          <label className={labelStyle}>Ingresos mensuales aproximados (COP)*</label>
          <div className="relative">
            <div className="absolute left-4 top-1/2 -translate-y-1/2 text-pink-600 font-bold">$</div>
            <input type="text" value={formattedIncome} onChange={handleIncomeChange} className={`${inputClass} pl-10`} placeholder="0" />
          </div>
        </div>
      </div>
    </div>
  );
};
